
import React from 'react'
import ContentLayout from '../../../../layout/contentLayout'
import styles from './scss/addworktualaddress.module.scss';
import { Link } from 'react-router-dom';

const AddWorktualAddress = () => {
    return (
        <ContentLayout noPaddingBlock={true}>
            <div className={styles.addemailaddresssec}>
                <div className='breadcrumbs'>
                    <ol>
                        <li>
                            <Link to='/Email configuration '>API configuration</Link>
                        </li>
                        <li>Add Worktual address</li>
                    </ol>
                </div>
                <div className={styles.topheading}>
                    <div className={styles.tophdlefts}>
                        <h2>Add Worktual address</h2>
                        <p className={styles.headerdesctxt}>Set up your Worktual email address and optional bot assistance.</p>
                    </div>
                </div>
                <form className='formsec'>

                    <div className='formrow'>
                        <div className='formlabels'>
                            <label htmlFor="">Email<span className='required'>*</span></label>
                            <span className='formelemdesc'>Enter the email username. Your domain is fixed as @mundio.worktual.com.</span>
                        </div>
                        <div className='formelements'>
                            <input type="text" name="" id="" placeholder='eg: @mundio.worktual.com' />
                        </div>
                    </div>
                    <div className='formrow'>
                        <div className='formlabels'>
                            <label htmlFor="ailasname">Ailas name</label>
                            <span className='formelemdesc'>Display name shown to recipients instead of the full email address.</span>
                        </div>
                        <div className='formelements'>
                            <input type="text" name="" id="ailasname" placeholder='Enter name' />
                        </div>
                    </div>
                    <div className='formrow'>
                        <div className='formlabels'>
                            <label htmlFor="ailasname">Bot assistance</label>
                        </div>
                        <div className='formelements'>
                            <div className={styles.botassist}>
                                <span className={styles.bttxt}>Enable your Bot for automated and regenerative assistance</span>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                        onChange={() => { }}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='formbtns'>
                        <button className='cancelbtn'>Cancel</button><button className='primarybtn'>Next</button>
                    </div>
                </form>
            </div>
        </ContentLayout>
    )
}

export default AddWorktualAddress
